function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M30.635 5.773a1 1 0 00-1.27-1.546l-28 23a1 1 0 001.27 1.546l28-23zM15.998 7.001c1.966-.029 3.933.423 5.8 1.178l-1.724 1.416c-1.347-.45-2.718-.7-4.059-.679h-.034c-4.592-.074-9.524 3.044-12.707 6.398a1 1 0 00-.274.684 1 1 0 00.274.684 24.337 24.337 0 004.028 3.404l-1.561 1.282a26.397 26.397 0 01-3.95-3.4l-.002-.003A2.87 2.87 0 011 15.998c0-.726.281-1.427.789-1.967l.003-.003c3.336-3.516 8.772-7.107 14.206-7.027z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 10c.996 0 1.935.243 2.762.672l-1.768 1.452a4 4 0 00-4.988 4.097l-1.77 1.454A6 6 0 0116 10zM21.944 15.176l-2.034 1.67A4.002 4.002 0 0116.072 20l-2.035 1.673a6 6 0 007.907-6.495z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.981 23.084a11.702 11.702 0 01-3.166-.409l-1.782 1.464c1.606.56 3.281.884 4.965.86 5.524.081 10.947-3.592 14.21-7.03l.003-.004A2.87 2.87 0 0031 15.998a2.87 2.87 0 00-.789-1.967l-.003-.003a26.269 26.269 0 00-3.303-2.927l-1.55 1.274c1.248.9 2.392 1.909 3.372 2.94a1 1 0 01.273.683 1 1 0 01-.274.684c-3.12 3.287-8.037 6.477-12.711 6.402h-.034z",
  fill: "currentColor"
})));